import { useAppSelector } from '../../../../../hooks/reduxHooks';
import { useAddCarcinogenicReportContractorMutation, useDeleteCarcinogenicContractorMutation, useEditCarcinogenicReportContractorMutation } from '../../../../../services/carcinogenicApi';

const useContractors = () => {
    const contractors = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.contratistas || []
    );

    const [addContractor, { isLoading: isAddingContractor }] =
        useAddCarcinogenicReportContractorMutation();
    const [editContractor, { isLoading: isEditingContractor }] =
        useEditCarcinogenicReportContractorMutation();
    const [deleteContractor, { isLoading: isDeletingContractor }] =
        useDeleteCarcinogenicContractorMutation();

    return {
        contractors,
        isAddingContractor,
        isEditingContractor,
        isDeletingContractor,
        addContractor,
        editContractor,
        deleteContractor
    };
};

export default useContractors;
